import { createRequiredContext } from 'src/context/createRequiredContext';

type IEscrowInvitationManagementContext = {
  openRejectConfirmation: (onConfirm: () => Promise<void>) => void;
};

export const [useEscrowInvitationManagement, EscrowInvitationManagementProvider] =
  createRequiredContext<IEscrowInvitationManagementContext>();
